import type { CellarsLine } from './cellars-texts.ts';

/**
 * The Furrows' scenes (docs/LABERINTOS.md, «La historia»): Brann in the barracks before the first run, and a short
 * word on coming back up, by how the run ended. Nobody says more than three lines in a row (the client test checks
 * it), and Brann gives his name and rank before anything else.
 */
const L = (who: CellarsLine['who'], key: string): CellarsLine => ({ who, key: `maze.scene.${key}` });

/** In the barracks: who asks, where to go, what is there and why, the prowler, and the rope. */
export const FURROWS_OPENING: CellarsLine[] = [
  L('narrator', 'o1'),
  L('brann', 'o2'),
  L('brann', 'o3'),
  L('brann', 'o4'),
  L('narrator', 'n1'),
  L('brann', 'o5'),
  L('brann', 'o6'),
  L('brann', 'o7'),
  L('narrator', 'n2'),
  L('brann', 'o8'),
];

/** Coming back up, by how the run ended. */
export const FURROWS_END: Record<'centre' | 'back' | 'torch' | 'fallen', CellarsLine[]> = {
  centre: [L('narrator', 'c1'), L('narrator', 'c2'), L('brann', 'c3'), L('narrator', 'c4')],
  back: [L('narrator', 'b1'), L('narrator', 'b2')],
  torch: [L('narrator', 't1'), L('narrator', 't2')],
  fallen: [L('narrator', 'f1'), L('narrator', 'f2')],
};

/** Every scene, for the tests. */
export const FURROWS_SCENES: CellarsLine[][] = [FURROWS_OPENING, ...Object.values(FURROWS_END)];
